import { render, staticRenderFns } from "./FinalInsuredSignBoard.vue?vue&type=template&id=89c4b424&scoped=true"
import script from "./FinalInsuredSignBoard.vue?vue&type=script&lang=js"
export * from "./FinalInsuredSignBoard.vue?vue&type=script&lang=js"
import style0 from "./FinalInsuredSignBoard.vue?vue&type=style&index=0&id=89c4b424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c4b424",
  null
  
)

/* custom blocks */
import block0 from "./FinalInsuredSignBoard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports